import React, { createContext, useState } from 'react';
export const ProfileContext = createContext(undefined);
export const ProfileContextProvider = ({ children }) => {
    const [profile, setProfile] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [permissions, setPermissions] = useState([]);
    return (React.createElement(ProfileContext.Provider, { value: {
            profile,
            permissions,
            setProfile,
            setPermissions,
            isLoading,
            setIsLoading
        } }, children));
};
//# sourceMappingURL=ProfileContext.js.map